module.exports = __webpack_public_path__ + "static/media/904ty@4x.3172ca9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/904ty@4x.png
// module id = 426
// module chunks = 0 1